module.exports = __webpack_public_path__ + "img/noviceattender.25784cb8.svg";